<template>
    <b-container fluid>
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('sales_distribution_admin.sales_dashboard') }}</h4>
            </template>
        </iq-card>
        <b-row v-show="result_category_selected === 'sales'">
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('sales_distribution_admin.salse') + ' ' + $t('globalTrans.list') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table :emptyText="$t('globalTrans.noDataFound')" show-empty bordered hover :items="listData" :fields="sales_columns" aria-hidden="loading | listReload ? 'true' : null">
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>
                                        <template v-slot:cell(usable_area)="data">
                                            <span class="capitalize">{{ data.item.usable_area }}</span>
                                        </template>
                                        <template v-slot:cell(status)="data">
                                            <span class="badge badge-warning" v-if="data.item.status == 1">{{$t('globalTrans.pending')}}</span>
                                            <span class="badge badge-success" v-else-if="data.item.status == 2">{{$t('globalTrans.approved')}}</span>
                                            <span class="badge badge-danger" v-else>{{$t('globalTrans.rejected')}}</span>
                                        </template>
                                        <template v-slot:cell(action)="data">
                                            <b-button v-b-modal.modal-1 variant=" iq-bg-success mr-1 mb-1" size="sm"><router-link :to="'/production-service/store-management/raw-material-requisition-entry?id='+data.item.id+'&&view='+data.item.id" class="iq-bg-success mr-1 mb-1" size="sm"><i class="ri-eye-line m-0"></i></router-link></b-button>
                                            <b-button variant=" iq-bg-success mr-1 mb-1" size="sm"><router-link :to="'/production-service/store-management/raw-material-requisition-entry?id='+data.item.id" class="iq-bg-success mr-1 mb-1" size="sm"><i class="ri-ball-pen-fill m-0"></i></router-link></b-button>
                                            <span v-if="data.item.status === 1">
                                                <b-button variant=" iq-bg-danger" size="sm" @click="remove(data.item)"><i class="fas fa-window-close m-0"></i></b-button>
                                            </span>
                                            <span v-if="data.item.status === 2">
                                                <b-button variant=" iq-bg-danger" size="sm" @click="remove(data.item)"><i class="fa fa-check m-0"></i></b-button>
                                            </span>
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        @input="searchData"
                                        />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
        <b-row v-show="result_category_selected === 'order'">
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('sales_distribution_admin.order') + ' ' + $t('globalTrans.list') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table :emptyText="$t('globalTrans.noDataFound')" show-empty bordered hover :items="listData" :fields="order_columns" aria-hidden="loading | listReload ? 'true' : null">
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>
                                        <template v-slot:cell(usable_area)="data">
                                            <span class="capitalize">{{ data.item.usable_area }}</span>
                                        </template>
                                        <template v-slot:cell(status)="data">
                                            <span class="badge badge-warning" v-if="data.item.status == 1">{{$t('globalTrans.pending')}}</span>
                                            <span class="badge badge-success" v-else-if="data.item.status == 2">{{$t('globalTrans.approved')}}</span>
                                            <span class="badge badge-danger" v-else>{{$t('globalTrans.rejected')}}</span>
                                        </template>
                                        <template v-slot:cell(action)="data">
                                            <b-button v-b-modal.modal-1 variant=" iq-bg-success mr-1 mb-1" size="sm"><router-link :to="'/production-service/store-management/raw-material-requisition-entry?id='+data.item.id+'&&view='+data.item.id" class="iq-bg-success mr-1 mb-1" size="sm"><i class="ri-eye-line m-0"></i></router-link></b-button>
                                            <b-button variant=" iq-bg-success mr-1 mb-1" size="sm"><router-link :to="'/production-service/store-management/raw-material-requisition-entry?id='+data.item.id" class="iq-bg-success mr-1 mb-1" size="sm"><i class="ri-ball-pen-fill m-0"></i></router-link></b-button>
                                            <span v-if="data.item.status === 1">
                                                <b-button variant=" iq-bg-danger" size="sm" @click="remove(data.item)"><i class="fas fa-window-close m-0"></i></b-button>
                                            </span>
                                            <span v-if="data.item.status === 2">
                                                <b-button variant=" iq-bg-danger" size="sm" @click="remove(data.item)"><i class="fa fa-check m-0"></i></b-button>
                                            </span>
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        @input="searchData"
                                        />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { materialRequisitionListApi } from '../../../../../../production-service/sales-distribution-admin/api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import flatpickr from 'flatpickr'
import { mapGetters } from 'vuex'

export default {
  mixins: [ModalBaseMasterList],
  data () {
    return {
      search: {
      },
      result_category_selected: 'sales',
      rows: []
    }
  },
  computed: {
      ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        }),
      MonthList: function () {
          const list = [
            { value: 1, text: this.$t('months.jan') },
            { value: 2, text: this.$t('months.feb') },
            { value: 3, text: this.$t('months.mar') },
            { value: 4, text: this.$t('months.apr') },
            { value: 5, text: this.$t('months.may') },
            { value: 6, text: this.$t('months.jun') },
            { value: 7, text: this.$t('months.jul') },
            { value: 8, text: this.$t('months.aug') },
            { value: 9, text: this.$t('months.sep') },
            { value: 10, text: this.$t('months.oct') },
            { value: 11, text: this.$t('months.nov') },
            { value: 12, text: this.$t('months.dec') }
          ]
          return list
        },
    salesCenterList: function () {
          return this.productCommonObj.salesCenterList
        },
    fiscalYearList: function () {
        const list = [
          { value: 1, text: '2016-2017' },
          { value: 2, text: '2017-2018' },
          { value: 3, text: '2018-2019' },
          { value: 4, text: '2019-2020' },
          { value: 5, text: '2020-2021' }
        ]
        const listbn = [
          { value: 1, text: '২০১৬-২০১৭' },
          { value: 2, text: '২০১৭-২০১৮' },
          { value: 3, text: '২০১৮-২০১৯' },
          { value: 4, text: '২০১৯-২০২০' },
          { value: 5, text: '২০২০-২০২১' }
        ]
        return this.$i18n.locale === 'bn' ? listbn : list
    },
    sales_columns () {
      const labels = [
            { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.pro_name'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.pro_unit'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.quantity'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.unit_price'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.total_price'), class: 'text-center' },
            { label: this.$t('globalTrans.status'), class: 'text-center' }
        ]

        let keys = []

        if (this.$i18n.locale === 'bn') {
            keys = [
                { key: 'index' },
                { key: 'product_name' },
                { key: 'product_unit' },
                { key: 'product_qty' },
                { key: 'unit_price' },
                { key: 'total_price' },
                { key: 'status' }
            ]
        } else {
            keys = [
                { key: 'index' },
                { key: 'product_name' },
                { key: 'product_unit' },
                { key: 'product_qty' },
                { key: 'unit_price' },
                { key: 'total_price' },
                { key: 'status' }
            ]
        }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    order_columns () {
      const labels = [
            { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.dealer_retailer_name'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.total_amount'), class: 'text-left' }
        ]

        let keys = []

        if (this.$i18n.locale === 'bn') {
            keys = [
                { key: 'index' },
                { key: 'dealer_retailer_name' },
                { key: 'total_amount' }
            ]
        } else {
            keys = [
                { key: 'index' },
                { key: 'dealer_retailer_name' },
                { key: 'total_amount' }
            ]
        }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    loadingState: function (newVal, oldVal) {
      if (newVal) {
        this.loadData()
      }
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
        flatpickr('#to_date', {})
        flatpickr('#from_date', {})
  },
  methods: {
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, materialRequisitionListApi, params).then(response => {
        if (response.success) {
            this.$store.dispatch('setList', response.data.data)
            this.paginationData(response.data)
        }
      })
      this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
    },
    getRelationalData (data) {
        const listData = data.map(item => {
            const evaluationData = {
                product_unit: item.product_unit !== undefined ? item.product_unit : '',
                product_name: item.product_name !== undefined ? item.product_name : '',
                usable_area: item.product_qty !== undefined ? item.usable_area : '',
                product_qty: item.usable_area !== undefined ? item.product_qty : ''
            }

            return Object.assign({}, item, evaluationData)
        })
        return listData
    }
  }
}
</script>
